import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/seniors_training.jpg";
import Tilt from "react-parallax-tilt";


import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";


function Senior2() {

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("/registration#seniors-section"); // This will navigate to the "/another-page" route
  };




    const videoId = "5mPU-mIQgoQ"; 
return (
    <Container fluid className="home-about-section" id="about">
    <Container>
        <Row>
        <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
            Empowering<span className="purple"> Seniors</span> with Technology
            </h1>
            <p className="home-about-body">
                        Choicest Fruit<span className="small-r-symbol">®</span> is committed to enriching the lives of senior citizens through our Digital
                         Literacy Program for Seniors, designed to equip participants with the skills needed to thrive
                          in today’s technology-driven world. Our hands-on program provides seniors with the tools to
                           confidently use smartphones, computers, and the internet, offering practical instruction in:
                        <br/>
                        <li><span className="purple">Troubleshooting common device issues</span> </li>
                        <li><span className="purple">Cybersecurity and safe online practices</span></li>
                        <li><span className="purple">Accessing online services, telehealth, and educational resources</span>  </li>
                        <li><span className="purple">Using AI (Artificial Intelligence) responsively</span>  </li>  
                        <li><span className="purple">Staying connected with loved ones through email and video calls</span> </li> 
                        <li><span className="purple">Collaborative tech projects with youth</span> </li>
                        <br />
                        <br />
                        <h2>Why Digital Literacy Matters</h2>
                         Digital skills enable seniors to:
                        <li>Maintain independence and confidence in daily life</li>
                        <li>Stay socially connected within community</li>
                        <li>Engage in lifelong learning, hobbies, and personal development </li>        
                        <br />
                        <h2>Our Mission</h2>
                         The Digital Literacy Program for Seniors is more than device training, 
                         it bridges the digital divide, strengthens independence, and enriches quality of life.
                          By participating, seniors unlock new opportunities for social connection, personal
                           growth, and active community engagement, leading to a more fulfilling, confident,
                            and connected life.      
                        <br/>
                        <br />
                        <h2>Our Approach</h2>                 

                         <li><span className="purple">Neighborhood-Based Learning</span> Programs are hosted at locations such as community centers, senior centers, and apartment complexes, making it easy for seniors to participate without transportation barriers.</li>
                         <li><span className="purple">Hands-On, Accessible Instruction</span> Seniors engage in interactive lessons that are paced and designed to accommodate all learning levels. This approach ensures participants gain real-world skills while building confidence and independence.</li>
                         <li><span className="purple">Lifelong Learning & Cognitive Health</span> Beyond technical skills, our program encourages creativity, personal growth, and cognitive stimulation through interactive activities, problem-solving, and exploration of digital tools.</li>
                         <li><span className="purple">Peer & Volunteer Support</span> Patient guidance from volunteers and small group sessions ensures seniors feel supported, empowered, and connected.</li>
                         <li><span className="purple">Intergenerational Learning & Knowledge Sharing</span> Seniors have the opportunity to share their experience and wisdom with younger generations while learning new digital skills themselves. This exchange strengthens community bonds, fosters mentorship, and encourages meaningful connections across ages.</li>
                         <li><span className="purple">Customized & Adaptive Learning</span> Lessons are tailored to participants’ skill levels and learning pace, accommodating physical, cognitive, or accessibility needs.</li>
                         <li><span className="purple">Safe & Supportive Environment</span> Seniors learn in a welcoming, non-judgmental setting where they can explore, ask questions, and practice technology without fear.</li>
                          <br />
                                               
                        
          </p>
          <Button onClick={handleClick}>Register Here</Button>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>SUMMER INTERNSHIP PROGRAM</h1>
          <Container>    
      
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', maxWidth: '100%', marginBottom: '20px' }}>
                                <iframe
                                    title="YouTube video"
                                    src={`https://www.youtube.com/embed/${videoId}`}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                    }}
                                />
      </div>
    </Container>
           
          </Col>
            </Row>

            
                <Col md={12} className="home-testimonial">
                <h1>TESTIMONIALS</h1>
                </Col>
          
            


      </Container>
    </Container>
  );
}
export default Senior2;
